<template>
  <div class="box box-info">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button-raised p-mr-2" style="float:right;" @click.prevent="openBasic"
                  icon="pi pi-plus"/>
        </div>
      </div>
      <Dialog header="Item Category" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">Category Name<span style="color:red">*</span></label>
            <InputText v-model.trim="categoryName" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <span>Depreciation</span>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="audit">Audit</label>
            <div class="p-field p-col-12 p-md-6">
              <Checkbox id="audit" v-model="audit" :binary="true"/>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="poolType">Pool Type</label>
            <Dropdown v-model="poolType" :options="poolTypeList"
                      optionLabel="name" placeholder="Select Pool Type" id="poolType"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="depreciation">Depreciation</label>
            <div class="p-field p-col-12 p-md-6">
              <span>{{ poolType.percentage }}</span>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="company">Company</label>
            <div class="p-field p-col-12 p-md-6">
              <Checkbox id="company" v-model="company" :binary="true"/>
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid" v-if="company === true">
          <div class="p-field p-col-12 p-md-6">
            <label for="depreciation">Depreciation</label>
            <InputText v-model="companyDepreciationPercentage" id="depreciation"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="lifeSpan">Life Span</label>
            <InputText v-model="lifeSpan" id="lifeSpan"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addCategory"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'ItemCategory',
  data() {
    return {
      displayBasic: false,
      categoryName: '',
      poolType: {},
      companyDepreciationPercentage: 0.0,
      audit: false,
      lifeSpan: 0,
      faItemGroupId: null,
      company: false,
      loading: false,
      editing: false
    }
  },
  mounted() {
    this.findPoolTypeList()
  },
  computed: {
    poolTypeList() {
      return this.$store.state.fa.poolTypeList
    }
  },
  methods: {
    async findPoolTypeList() {
      await this.$store.dispatch('loadPoolTypeList')
    },
    async addCategory() {
      if (this.categoryName === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Category Name cannot be empty!', life: 3000})
        return
      }
      let category = {
        id: this.faItemGroupId,
        value: this.name,
        isFixedAssets: true,
        faAudit: this.audit,
        faPoolType: this.poolType,
        lifeSpan: this.lifeSpan,
        poolId: this.poolId,
        companyDepreciationPercentage: this.companyDepreciationPercentage
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createFaItemGroup', category)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', category)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.categoryName = ''
      this.poolType = {}
      this.company = false
      this.audit = false
      this.depreciation = 0
      this.lifeSpan = 0
      this.displayBasic = false
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.reset()
      // this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    Checkbox,
    Dropdown
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// categorySetup.vue?52b15fc0